import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import SettingsIcon from '@mui/icons-material/Settings';
import ReactDOMServer from 'react-dom/server';

/**
 * Controle nativo do Leaflet para abrir o painel de configuração de camadas
 * Props: onOpen (função para abrir o modal)
 */
const LayerStyleConfigButton = ({ onOpen }) => {
  const map = useMap();

  useEffect(() => {
    const configControl = L.Control.extend({
      options: { position: 'topright' },
      onAdd: function () {
        const container = L.DomUtil.create(
          'div',
          'leaflet-bar leaflet-control layer-style-config-btn',
        );
        // Renderizar ícone MUI como SVG
        container.innerHTML = ReactDOMServer.renderToString(
          <SettingsIcon style={{ fontSize: 22, color: '#1976d2' }} />,
        );
        container.title = 'Configurar estilos das camadas';
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        container.style.cursor = 'pointer';
        container.style.width = '34px';
        container.style.height = '34px';
        container.style.background = 'white';
        container.style.borderRadius = '6px';
        container.style.boxShadow = '0 1px 4px rgba(0,0,0,0.18)';
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        L.DomEvent.on(container, 'click', function (e) {
          L.DomEvent.stopPropagation(e);
          L.DomEvent.preventDefault(e);
          if (typeof onOpen === 'function') onOpen();
        });
        return container;
      },
    });
    const control = new configControl();
    map.addControl(control);
    return () => {
      map.removeControl(control);
    };
  }, [map, onOpen]);
  return null;
};

export default LayerStyleConfigButton;
